import {
  FdInfoBold,
  FdInfoCircle,
  FdSave,
  FdWarningDanger,
} from '@qodly/icons';

export const ModalIcons = {
  FdSave,
  FdWarningDanger,
  FdInfoCircle,
  FdInfoBold,
};

export type ModalIcon = keyof typeof ModalIcons;

export enum ModalType {
  ALERT = 'alert',
  CONFIRM = 'confirm',
  // PROMPT = 'prompt',
}

export enum ModalColor {
  PRIMARY = 'primary',
  WARNING = 'warning',
  DANGER = 'danger',
}

export enum ModalCloseReason {
  CONFIRMED = 'confirmed',
  CANCELED = 'canceled',
}

export interface IModal {
  /**
   * Id of the modal
   */
  id: string;
  type: ModalType;
  color?: ModalColor;
  /**
   * title displayed at the header of the modal
   */
  title?: string;
  /**
   * The message to be displayed at the center of the modal.
   */
  message: string;
  views?: {
    /**
     * additional warnings to be displayed in a list view under the message.
     */
    tips?: { type: 'warning' | 'error' | 'info'; message: string }[];
    toggles?: Record<
      string,
      {
        key: string;
        value: boolean;
        title: string;
        warnings?: { type: 'warning' | 'error' | 'info'; message: string }[];
      }
    >;
  };
  icon?: ModalIcon; // icon name
  zIndex?: number;
  isOpen: boolean;
  closeReason?: ModalCloseReason;
}
